import { useQuery } from '@apollo/client';

import { QueryHookOptions } from '../..';
import { QUOTES } from '../quoteTypeDefs';

export const useQueryGetQuotes = (options?: QueryHookOptions<typeof QUOTES>) =>  (
  useQuery(QUOTES, options)
);
